(ns minorodata.connections.sources.outreach
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::outreach-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


(def source
  {:id                "outreach"
   :enabled           false
   :name              "Outreach (Deprecated)"
   :description       "Sales engagement platform, sales automation software"
   :image-source      "outreach.svg"
   :tags              ["marketing"]

   :preview-formatter (fn [source]
                        (if (:is-token-valid source)
                          (str "Authenticated by token")
                          [:span {:class "text-kleene-error-01"
                                :title         "TOKEN EXPIRED"}
                           "AUTH TOKEN EXPIRED"]))

   :form              {:format-for-api
                       (fn [data]
                         (let [{:keys [auth-credentials name description]} data]
                           {:source-type "outreach"
                            :name        name
                            :description description
                            :source      {:auth-credentials-id (:auth-credentials-id auth-credentials)
                                          :is-token-valid      (:is-token-valid auth-credentials)
                                          :has-third-leg       true}}))

                       :format-for-inputs
                       (fn [data]
                         (let [{:keys [source name description]} data
                               {:keys [auth-credentials-id is-token-valid]} source]
                           {:name                name
                            :description         description

                            :auth-credentials    (when (and (some? auth-credentials-id)
                                                            (some? is-token-valid))
                                                   {:auth-credentials-id auth-credentials-id
                                                    :is-token-valid      is-token-valid})
                            :auth-credentials-id auth-credentials-id
                            :is-token-valid      is-token-valid}))

                       ;; TODO:
                       ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
                       ;; {:block-type :input
                       ;;  :name       :some-name
                       ;;  :mapping    [:credentials :some_name]}
                       ;; Also, think of having `:input-type :hidden` blocks as placeholders
                       ;; for static fields in the final configuration.

                       :validate (partial form-component/validate-form ::outreach-form)

                       :id :outreach-form

                       :blocks
                       [{:block-type :input
                         :label      "Source name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type           :oauth
                         :label                "Outreach Login"
                         :name                 :auth-credentials
                         :required             true

                         :request-uri          "https://api.outreach.io/oauth/authorize"
                         :params-processor     (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                                 {:response_type response-type
                                                  :scope         scope
                                                  :client_id     client-id
                                                  :redirect_uri  redirect-uri
                                                  :state         state})

                         :response-processor   (fn [data]
                                                 (select-keys data [:auth-credentials-id :is-token-valid]))

                         :oauth-connector-type "outreach"
                         :has-third-leg        true

                         :response-type        "code"
                         :client-id            "not-set"
                         :scope                "proespects.read opportunities.read accounts.read"}

                        {:block-type :submit
                         :content    "SAVE"}]}

   :extract-form      {:format-for-api
                       (fn [{:keys [name description status action destination-table report]}]
                         {:name          name
                          :description   description
                          :status        status
                          :output-tables [destination-table]
                          :config        {:extracts [{:action            action
                                                      :report            report
                                                      :destination-table destination-table}]}})

                       :format-for-inputs
                       (fn [data]
                         (let [{:extract/keys [name description status config]} data
                               extract (get-in config [:extracts 0])]
                           (merge
                            (select-keys extract [:report :action :destination-table])
                            (app.utils/keep-non-nil-keys
                             {:name          name
                              :description   description
                              :status        status
                              :output-tables []}))))

                       :validate
                       (constantly nil)

                       :id
                       :outreach-extract-form

                       :blocks
                       [{:block-type :input
                         :label      "Extract name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :select
                         :label      "Status"
                         :name       :status
                         :options    [{:name "Active" :value "active"}
                                      {:name "Paused" :value "paused"}]
                         :required   true
                         :value      "active"}

                        {:block-type :subtitle
                         :content    "Extract Configuration"}

                        {:block-type :select
                         :label      "Report"
                         :name       :report
                         :options    [{:name "NOT IMPLEMENTED" :value "not-implemented"}]
                         :disabled   true
                         :required   true
                         :value      "not-implmented"}

                        {:block-type :subtitle
                         :content    "Data loading options"}

                        {:block-type :select
                         :label      "Load method"
                         :name       :action
                         :options    [{:name "Drop, Create, Load" :value "replace"}
                                      {:name "Truncate, Load"     :value "reload"}
                                      {:name "Append"             :value "append"}]
                         :required   true
                         :value      "replace"}

                        {:content "Drop table, Create table, load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "replace"]]}

                        {:content "Truncate table, Load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "reload"]]}

                        {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                         :conditions [[:eq [:action :value] "append"]]}

                        {:block-type :subtitle
                         :content    "Destination table"}

                        {:block-type  :warehouse-destination
                         :name        :destination-table}

                        {:block-type :submit
                         :content    "SAVE"}]}})
